import Vue from 'vue'
import QuillEmoji from 'quill-emoji'

Vue.use(QuillEmoji)
